import { render, staticRenderFns } from "./layoutEditor.vue?vue&type=template&id=63c70722&scoped=true&"
import script from "./layoutEditor.vue?vue&type=script&lang=js&"
export * from "./layoutEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c70722",
  null
  
)

export default component.exports